// imports
import Components from 'minsky-kit/js/components/Component';
import gsap from 'gsap';
import { blockScroll, unblockScroll } from '../utils/scroll';

// private statics

// class definition
export default class HeaderSlideOut extends Components {
    // constructor
    constructor (args = {}, objectName = 'HeaderSlideOut') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // set properties
        this._isOpen = false;
        this._transparent = args._transparent || false,
        this._isMobile = null;
        this._tl = {
            open:  null,
            close: null,
        };

        // cache some selections
        this._$triggers = args.$triggers,
        this._$title = this.$el.querySelector('.header__reservation-title'),
        this._$view = this.$el.querySelector('.view'),
        this._$items = this.$el.querySelectorAll('.views-row'),
        this._$links = this.$el.querySelectorAll('.views-row .store-small-t__link'),
        this._$closeBtn = this.$el.querySelector('.header__locations-close-button'),
        this._$emptyMsg = this.$el.querySelector('.view-content--empty');

        // init timelines
        this._tl.open = new gsap.timeline({
            ease:          'Power3.easeOut',
            paused:        true,
            repeatRefresh: true,
            onComplete:    this.blm.addOnce('onOpenCompleted', onOpenCompleted),
        });
        this._tl.close = new gsap.timeline({
            ease:          'Power3.easeOut',
            paused:        true,
            repeatRefresh: true,
            onStart:       this.blm.addOnce('onCloseCompleted', onCloseCompleted),
        });

        // init tweens
        this._tl.open
            .to([this._$title, this._$emptyMsg, ...this._$items, this._$closeBtn], {
                opacity:  1,
                duration: 0.25,
                stagger:  0.04,
            }, 0.125);

        this._tl.close
            .to([this._$title, this._$emptyMsg, ...Array.from(this._$items).reverse(), this._$closeBtn], {
                opacity:  0,
                duration: 0.5,
            });

        // add listeners
        this._$triggers.forEach((t) => t.addEventListener('click', this.blm.addOnce('onTriggerClick', onTriggerClick)));
        this._$links.forEach((l) => l.addEventListener('click', this.blm.addOnce('onLinkClick', onLinkClick)));
        this._$closeBtn.addEventListener('click', this.blm.add('onCloseClick', onCloseClick));

        // set the title using the trigger label
        if (this._$triggers[0]) this._$title.innerText = this._$triggers[0].innerText;
    }

    // methods
    open (force) {
        if (!this._isOpen || force) {
            this._isOpen = true;
            this._tl.open
                .invalidate()
                .restart();

            this.$el.classList.add('header__locations--open');
        }

        if (this._isMobile) blockScroll('header-slide-out');

        this.dispatch('open');
    }

    close (force) {
        if (this._isOpen || force) {
            this._isOpen = false;
            this._tl.close
                .invalidate()
                .restart();

            this.$el.classList.remove('header__locations--open');
        }

        unblockScroll('header-slide-out');

        this.dispatch('close');
    }

    toggle (force) {
        if (this._isOpen) {
            this.close();
        }
        else {
            this.open();
        }
    }

    refresh () {
        if (this._isOpen) {
            this.open(true);
        }
        else {
            this.close(true);
        }
    }

    destroy () {
        super.destroy();
    }

    // getters & setters
    get isOpen () {
        return this._isOpen;
    }

    get mobile () {
        return this._isMobile;
    }

    set mobile (value) {
        if (this._isMobile != value) {
            this._isMobile = value;

            if (value === true) {
                if (this._isOpen) blockScroll('header-slide-out');
            }
            else if (value === false) {
                unblockScroll('header-slide-out');
            }
        }
    }
}

// Utils

// Event handlers
function onTriggerClick (e) {
    e.preventDefault();
    this.toggle();
}

function onLinkClick (e) {
    this.dispatch('linkClick', {
        originalEvent: e,
    });
}

function onCloseClick (e) {
    e.preventDefault();

    this.close();
}

function onOpenCompleted () {
    this.$el.style.overflow = 'auto';
}

function onCloseCompleted () {
    this.$el.style.overflow = 'hidden';
}
